import type { MenuType } from 'types'

import Accordion from '../../../../Accordion'
import AccordionLinks from '../../../../Accordion/AccordionLinks'

import style from '../style.scss'

type Links = {
  links: Array<MenuType>
  text: string
}
export type LinkMenus = Array<Links>

type Props = {
  below?: React.ReactNode
  className?: string
  handleMenuClose: () => void
  linkMenus: LinkMenus
}

Menu.defaultProps = {
  className: '',
  menuIndex: 0,
  parentIndexes: [],
}

const formatAccordion = (linkMenus: LinkMenus, handleMenuClose: () => void) =>
  linkMenus.map(({ text, links }) => ({
    summary: text,
    details: (
      <AccordionLinks
        key={text}
        className={style.submenuLink}
        handleToggle={handleMenuClose}
        links={links}
        variant='condensed'
      />
    ),
  }))

function Menu(props: Props) {
  const { below, className, linkMenus, handleMenuClose } = props

  return (
    <div className={className}>
      <Accordion
        className={style.accordion}
        items={formatAccordion(linkMenus, handleMenuClose)}
        showBottomBorders
        variant='white-condensed'
      />
      {below && <div onClick={handleMenuClose}>{below}</div>}
    </div>
  )
}

export default Menu
